module.exports = __webpack_public_path__ + "static/img/bcg.3f6a1cb7.webp";